module.exports = __webpack_public_path__ + "static/img/part11.bb87ab8.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/activity4/part11.png
// module id = AaSn
// module chunks = 7